import React from 'react';
import DocumentPage from '@/app/pages/document-detail';
import AuditorContextProvider from '../components/AuditorContextProvider';
import { useNavigate } from 'react-router-dom';

/**
 * Auditor Document Detail component
 * 
 * Renders a read-only version of the Document Detail page for auditor view
 * We use AuditorContextProvider to get the context providers but avoid duplicate headers
 */
const AuditorDocumentDetail: React.FC = () => {
  const navigate = useNavigate();

  // Create a navigation handler for back button
  const handleBackNavigation = () => {
    // Navigate back to auditor document library
    navigate('/auditor-view/document-library');
  };

  return (
    <AuditorContextProvider>
      {/* Pass the custom back navigation handler to document detail page */}
      <DocumentPage 
        isReadOnly={true}
        onBackNavigation={handleBackNavigation} 
      />
    </AuditorContextProvider>
  );
};

export default AuditorDocumentDetail;
